var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOmr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3411)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#F50101"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3411)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.625,
    height: 23,
    fill: "#F50101"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74943 1.83453C7.75266 1.78632 7.68798 1.77182 7.66868 1.81612C7.43764 2.34649 6.77286 3.80192 5.63998 5.73658V4.85713C5.53732 4.70838 5.21007 4.3082 5.21007 4.3082V3.43006L5.80209 2.71573L4.98899 1.91653L4.132 2.71573L4.77977 3.43006V4.3082C4.77977 4.72929 4.38705 4.85713 4.38705 4.85713L4.31515 5.63174C3.25442 3.79522 2.61685 2.38732 2.38209 1.84286C2.36257 1.79759 2.29681 1.81323 2.3018 1.86228C2.36572 2.4907 2.5905 4.15412 3.29316 5.93812H3.11637V5.86711C3.11637 5.84309 3.09691 5.82363 3.07289 5.82363H1.51922C1.49521 5.82363 1.47575 5.84309 1.47575 5.86711V7.21765C1.47575 7.24166 1.49521 7.26113 1.51922 7.26113H3.07289C3.09691 7.26113 3.11637 7.24166 3.11637 7.21765V6.5106H3.30725C3.37199 6.70965 3.52067 6.84994 3.69454 6.854C3.816 7.10386 3.94772 7.35305 4.09056 7.59911C3.76199 7.55579 1.59038 7.30927 1.59038 8.36266C1.59038 8.99142 2.11858 9.32424 2.781 9.49627C2.04144 10.3892 1.34789 11.2237 1.1127 11.5065C1.08572 11.539 1.11661 11.5831 1.15689 11.5706C1.58874 11.4361 3.03619 10.9191 4.40988 9.6696L4.45008 9.66967C4.8136 9.66967 5.06643 9.45941 5.24216 9.17481C6.66321 10.7214 8.28627 11.3671 8.82667 11.55C8.87071 11.5649 8.90015 11.5102 8.86557 11.4791C8.43883 11.0955 7.14498 9.87152 5.81907 8.01111L5.85075 7.96165C6.09709 7.57405 6.31173 7.17535 6.49876 6.77559C6.57702 6.71457 6.63934 6.62175 6.6755 6.5106H6.86637L6.86637 7.21765C6.86637 7.24166 6.88584 7.26113 6.90985 7.26113H8.46352C8.48753 7.26113 8.507 7.24166 8.507 7.21765V5.86711C8.507 5.84309 8.48753 5.82363 8.46352 5.82363H6.90985C6.90423 5.82363 6.89887 5.82469 6.89394 5.82663C7.54613 4.05832 7.70976 2.42806 7.74943 1.83453ZM6.86637 5.93812L6.86637 5.90069L6.85224 5.93812H6.86637ZM4.05387 6.28734C4.05387 6.54344 3.89647 6.75105 3.70231 6.75105C3.50815 6.75105 3.35075 6.54344 3.35075 6.28734C3.35075 6.03124 3.50815 5.82363 3.70231 5.82363C3.89647 5.82363 4.05387 6.03124 4.05387 6.28734ZM5.92887 6.28734C5.92887 6.54344 6.08627 6.75105 6.28043 6.75105C6.4746 6.75105 6.632 6.54344 6.632 6.28734C6.632 6.03124 6.4746 5.82363 6.28043 5.82363C6.08627 5.82363 5.92887 6.03124 5.92887 6.28734Z",
    fill: "#F7FCFF"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3411)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3411",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmr);
export default __webpack_public_path__ + "static/media/OMR.464493372eb0ee9e24e4a4a0f84c543b.svg";
export { ForwardRef as ReactComponent };